import axios from 'axios';
import { BASE_URL, handleError, apiRequest } from '../apiSettings';
import { API_ENDPOINTS } from './apiEndpoints';


export const uploadDocument = async (formData: any, setUploadProgress: any, chunkNumber: any, filename: any) => {
    const token = localStorage.getItem('jwt-token');
    if (!token) {
        alert("Not Authenticated");
        return 'Token not found';
    }

    const apiClient = axios.create({
        baseURL: BASE_URL,
        headers: {
            Authorization: `Bearer ${token}`
        },
    });

    try {
        const response:any = await apiClient.post('/upload-file', formData, {
            onUploadProgress: (event: any) => {
                const currentProgress = Math.round((event.loaded / event.total) * 100);
                setUploadProgress((prev: any) => ({ ...prev, [filename]: currentProgress }));
            }
        });
        return response?.data;
    } catch (error: any) {
        console.error(`Error uploading chunk ${chunkNumber}:`, error);
        return false;
    }
};

export const fetchDocuments = async () => {
    const token = localStorage.getItem('jwt-token');
    if (!token) {
        console.log("Not Authenticated");
        return [];
    }

    const apiClient = axios.create({
        baseURL: BASE_URL,
        headers: {
            Authorization: `Bearer ${token}`
        },
    });

    try {
        const response = await apiClient.get(`${BASE_URL}/files`);
        return response.data.documents;
    } catch (error: any) {
        console.error('Error fetching documents:', error);
        throw error;
    }
};

export const deleteDocument = async (documentId: string) => {
    console.log('delete document ' + documentId);
    return apiRequest('delete')(`/documents/${documentId}`);
};

export const fetchFileUrl = async (id: any) => {
    const token = localStorage.getItem('jwt-token');
    if (!token) {
        alert("Not Authenticated");
        return null;
    }

    const apiClient = axios.create({
        baseURL: BASE_URL,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
    });

    try {
        const response = await apiClient.get(`${API_ENDPOINTS.FETCH_FILE_URL}/${id}`, {
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        return url;
    } catch (error) {
        handleError(error);
        return null;
    }
};